import { Link } from 'react-router'

import Add from '../../../../assets/icons/Add'
import { SVGWrapper } from '../../../../components'
import { AddButtonBox, AddIcon, StyledLink } from '../../styled'

const AddInvestmentButton = ({ linkAddress }) => {
  return (
    <Link to={linkAddress}>
      <AddButtonBox>
        <AddIcon>
          <SVGWrapper svg={Add} size='medium' />
        </AddIcon>
        <StyledLink>Add new investment</StyledLink>
      </AddButtonBox>
    </Link>
  )
}

export default AddInvestmentButton
